export default __webpack_public_path__ + "static/casa-coberturas-6e843f9babc19f9ca8a203abfcab529a.png";